/**
 * The Details table's row order on every order page (Andy, 3 Oct 2026): what the record is, how
 * it was paid, then the identifiers with each local id directly above its Stripe twin. Rows whose
 * label is not listed keep their relative order after the known ones.
 */
export const DETAIL_ROW_ORDER = [
  'Order ID',
  'Booking ID',
  'Event',
  'Form title',
  'Created',
  'Payment type',
  'Payment method',
  'SKU',
  'Prefilled',
  'Checkout Page fee',
  'Customer ID',
  'Stripe customer ID',
  'Payment ID',
  'Stripe charge ID',
  'Subscription ID',
  'Stripe subscription ID',
  'Submission ID',
];

const rank = row => {
  const index = DETAIL_ROW_ORDER.indexOf(row.label);
  return index === -1 ? DETAIL_ROW_ORDER.length : index;
};

export default function sortDetailRows(rows) {
  return rows
    .map((row, index) => ({ row, index }))
    .sort((a, b) => rank(a.row) - rank(b.row) || a.index - b.index)
    .map(({ row }) => row);
}
